const InfoIcon = () => {
    return (
        <svg className={'svg-icon'} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 21C17.4706 21 21.5 16.9706 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21Z"
                stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M12.5 9.375C13.3284 9.375 14 8.70343 14 7.875C14 7.04657 13.3284 6.375 12.5 6.375C11.6716 6.375 11 7.04657 11 7.875C11 8.70343 11.6716 9.375 12.5 9.375Z"
                fill="#7B7E7C"/>
            <path d="M11.75 11.25H12.5V16.5H13.25" stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export default InfoIcon